/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_stats_showing_fantasy = /** @type {(inputs: { season: NonNullable<unknown>, count: NonNullable<unknown>, entity: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.season} season fantasy statistics — ${i?.count} ${i?.entity}`)
};

const es_f1_stats_showing_fantasy = /** @type {(inputs: { season: NonNullable<unknown>, count: NonNullable<unknown>, entity: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mostrando estadísticas fantasy ${i?.season} — ${i?.count} ${i?.entity}`)
};

const de_f1_stats_showing_fantasy = /** @type {(inputs: { season: NonNullable<unknown>, count: NonNullable<unknown>, entity: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.season} Fantasy-Statistiken — ${i?.count} ${i?.entity}`)
};

const nl_f1_stats_showing_fantasy = /** @type {(inputs: { season: NonNullable<unknown>, count: NonNullable<unknown>, entity: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.season} fantasy-statistieken — ${i?.count} ${i?.entity}`)
};

const fr_f1_stats_showing_fantasy = /** @type {(inputs: { season: NonNullable<unknown>, count: NonNullable<unknown>, entity: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Statistiques fantasy ${i?.season} — ${i?.count} ${i?.entity}`)
};

const it_f1_stats_showing_fantasy = /** @type {(inputs: { season: NonNullable<unknown>, count: NonNullable<unknown>, entity: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Statistiche fantasy stagione ${i?.season} — ${i?.count} ${i?.entity}`)
};

const pt_br2_f1_stats_showing_fantasy = /** @type {(inputs: { season: NonNullable<unknown>, count: NonNullable<unknown>, entity: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estatísticas fantasy ${i?.season} — ${i?.count} ${i?.entity}`)
};

const pt_f1_stats_showing_fantasy = /** @type {(inputs: { season: NonNullable<unknown>, count: NonNullable<unknown>, entity: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estatísticas fantasy ${i?.season} — ${i?.count} ${i?.entity}`)
};

const ja_f1_stats_showing_fantasy = /** @type {(inputs: { season: NonNullable<unknown>, count: NonNullable<unknown>, entity: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.season}年ファンタジー統計 — ${i?.count} ${i?.entity}`)
};

const zh_f1_stats_showing_fantasy = /** @type {(inputs: { season: NonNullable<unknown>, count: NonNullable<unknown>, entity: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.season}年梦幻统计 — ${i?.count} ${i?.entity}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ season: NonNullable<unknown>, count: NonNullable<unknown>, entity: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_stats_showing_fantasy = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_stats_showing_fantasy(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_stats_showing_fantasy", locale)
	if (locale === "en") return en_f1_stats_showing_fantasy(inputs)
	if (locale === "es") return es_f1_stats_showing_fantasy(inputs)
	if (locale === "de") return de_f1_stats_showing_fantasy(inputs)
	if (locale === "nl") return nl_f1_stats_showing_fantasy(inputs)
	if (locale === "fr") return fr_f1_stats_showing_fantasy(inputs)
	if (locale === "it") return it_f1_stats_showing_fantasy(inputs)
	if (locale === "pt-BR") return pt_br2_f1_stats_showing_fantasy(inputs)
	if (locale === "pt") return pt_f1_stats_showing_fantasy(inputs)
	if (locale === "ja") return ja_f1_stats_showing_fantasy(inputs)
	return zh_f1_stats_showing_fantasy(inputs)
};